/** Текстове на началната страница (меню, заглавна секция, секции, долен колонтитул). */
export default {
  logo: {
    tagline: "AI творческо студио",
  },
  hero: {
    bgAlt: "Абстрактен холографски фон с вълни",
    chipOutput: "Full HD видео",
    chipEngine: "Невронен двигател",
    chipRender: "AI генериране",
    badge: "AI студио за изображения и видео от ново поколение",
    title: "<holo>Изображения и видео</holo> с изкуствен интелект за професионалисти",
    subtitle:
      "Създавайте впечатляващи визии мигновено с изкуствен интелект от ново поколение. Кинематографично качество без нужда от обучение.",
    viewPricing: "Вижте цените",
    stats: {
      output: { value: "1080p", label: "Макс. резолюция на видео" },
      models: { value: "1 точка", label: "За изображение" },
      render: { value: "2 точки", label: "За видеоклип" },
      uptime: { value: "10", label: "Безплатни точки за начало" },
    },
  },
  howItWorks: {
    eyebrow: "Как работи",
    title: "От идея до кинематографична визия в три стъпки",
    subtitle: "Не са нужни дизайнерски умения. Ние поемаме тежката работа, а вие се съсредоточавате върху творчеството.",
    steps: {
      upload: {
        title: "Описание",
        description:
          "Напишете кратък промпт, който описва изображението или видеото, което искате — обект, стил, осветление и настроение.",
      },
      generate: {
        title: "Генериране",
        description:
          "Нашият AI създава изображението ви за секунди или го анимира в кратък кинематографичен видеоклип. Едно изображение струва 1 точка, а видеоклип — 2 точки.",
      },
      download: {
        title: "Изтегляне",
        description:
          "Изтеглете изображения до 1024 × 1024 px и видеоклипове до Full HD (1080p) с пълни права за търговска употреба.",
      },
    },
  },
  demo: {
    eyebrow: "AI демо",
    title: "Вижте как груба скица се превръща в шедьовър",
    subtitle: "Плъзнете разделителя, за да сравните. Това е същата система, която ще задвижи следващия ви проект.",
    sketch: "Скица",
    aiGenerated: "Създадено с AI",
    altGenerated: "{{subject}} — генерирано изображение",
    altSketch: "{{subject}} — скица",
    perfumeBottle: "Бутилка парфюм",
    portrait: "Портрет",
    videoAlt: "Преглед на видео, генерирано с AI",
    playVideo: "Пуснете видеото",
    videoBadge: "Видеоклип — Full HD",
    generateTitle: "Генерирайте свое изображение",
    generateSubtitle: "Опишете каквото пожелаете и нашата система ще го създаде за секунди.",
    promptPlaceholder: "Кинематографичен портрет на лисица под неоновите светлини на града…",
    generate: "Генерирай",
    generating: "Генериране…",
    rendering: "Генерираме вашето изображение…",
    resultAlt: "Изображение, генерирано с AI",
    noImage: "Не беше върнато изображение. Моля, опитайте отново.",
    genericError: "Нещо се обърка при генерирането.",
  },
  pricing: {
    eyebrow: "Цени",
    title: "Прости планове, кинематографични резултати",
    subtitle: "Започнете с 10 безплатни точки. Купете пакет точки, когато имате нужда от още — еднократно плащане, а не абонамент.",
    mostPopular: "Най-популярен",
    footnote: "Сигурно плащане с карта · Еднократно плащане, без абонамент · 30 дни гаранция за връщане на парите",
  },
  faq: {
    eyebrow: "Въпроси",
    title: "Често задавани въпроси",
    items: {
      howItWorks: {
        question: "Как работи генерирането с AI?",
        answer:
          "Вие пишете текстов промпт. Нашите AI модели го тълкуват и създават изцяло ново изображение от нулата — без стокови библиотеки и без шаблони. За видео генерираното изображение се анимира в кратък кинематографичен клип. Можете да прецизирате промпта и да генерирате отново, докато резултатът не съвпадне с вашата представа.",
      },
      formats: {
        question: "Кои формати поддържате?",
        answer:
          "Изображенията се изтеглят като JPEG или PNG с резолюция до 1024 × 1024 px. Видеоклиповете се изтеглят като MP4 с резолюция до Full HD (1080p). Всички планове получават едно и също качество, без воден знак и с пълни права за търговска употреба.",
      },
      payments: {
        question: "Как работят плащанията?",
        answer:
          "Всеки план е еднократно плащане за пакет точки — това не е абонамент и нищо не се подновява автоматично. Плащате сигурно с карта на защитената страница за плащане на Банка ДСК или Пощенска банка, с всяка основна кредитна или дебитна карта. Цените са в евро (EUR) и включват всички приложими данъци, без скрити такси и без минимална сума на поръчката.",
      },
      freePoints: {
        question: "Какво включват 10-те безплатни точки?",
        answer:
          "Всеки нов профил получава еднократно 10 безплатни точки при регистрацията – достатъчни за 10 изображения или 5 видеоклипа. Не въвеждате карта, това не е пробен период, който се превръща в платен план, и след това не се таксува нищо. Плащате само ако решите да купите пакет точки, а всеки пакет е еднократно плащане.",
      },
      security: {
        question: "Защитени ли са данните ми?",
        answer:
          "Да. Всичко, което ни изпращате, се пренася по криптирани HTTPS връзки, паролите се съхраняват само като еднопосочни хешове, а пълните данни на картата ви никога не достигат до нас – въвеждате ги на съвместимата с PCI DSS страница за плащане на банката, защитена с 3-D Secure. Не използваме промптовете или резултатите ви за обучение на AI модели и запазвате пълната собственост върху всичко, което генерирате. Подробности ще намерите в Политиката за поверителност.",
      },
      refunds: {
        question: "Каква е политиката ви за възстановяване на суми?",
        answer:
          "Първото плащане на план Starter, Pro или Elite има 30-дневна гаранция за връщане на парите. Ако не сте използвали точки от покупката, възстановяваме цялата сума. Ако сте използвали част от тях, възстановяваме неизползваните точки. Планът Custom се възстановява в срок от 14 дни на същия принцип. Плановете са еднократни покупки, така че никога не таксуваме отново, освен ако не направите нова поръчка.",
      },
    },
  },
  contact: {
    eyebrow: "Контакти",
    title: "Да създадем нещо кинематографично",
    subtitle:
      "Имате въпрос за плановете, нужда от помощ с проект или искате персонализиран процес за екипа си? Пишете ни — отговаряме в рамките на един работен ден.",
    emailUs: "Пишете ни",
    supportEmail: "Поддръжка",
    registeredBusiness: "Регистрирана фирма",
    companyName: "МЕДИА СТИЛ 25 ЕООД (MEDIA STYLE 25 EOOD)",
    uic: "ЕИК: 208512111 · Разград, България",
    registeredAddress: "Адрес на управление",
    address: "бул. „Априлско въстание“ № 7, вх. Б, ет. 1, ап. 34, 7200 Разград, България",
    callUs: "Обадете ни се",
    customerService: "Обслужване на клиенти",
    workingHours: "Работно време",
    hours: "Понеделник – петък, 09:00 – 18:00 ч. (българско време)",
    responseTime: "Време за отговор",
    within24h: "До един работен ден",
    name: "Име",
    namePlaceholder: "Вашето име",
    email: "Имейл",
    subject: "Тема",
    subjectPlaceholder: "За какво се отнася?",
    message: "Съобщение",
    messagePlaceholder: "Разкажете ни от какво имате нужда…",
    messageHint: "До 500 знака.",
    sending: "Изпращане…",
    send: "Изпрати съобщението",
    success: "Благодарим ви! Съобщението ви е изпратено. Ще се свържем с вас скоро.",
    networkError: "Грешка в мрежата. Моля, проверете връзката си и опитайте отново.",
  },
  footer: {
    about:
      "MEDIA-STYLE е търговското наименование на МЕДИА СТИЛ 25 ЕООД — българска творческа технологична компания, която създава AI инструменти за генериране на изображения и видео.",
    company: "Компания",
    howItWorks: "Как работи",
    legal: "Правна информация",
    contact: "Обслужване на клиенти",
    registered: "МЕДИА СТИЛ 25 ЕООД (MEDIA STYLE 25 EOOD) · ЕИК 208512111 · Седалище: Разград, България · Държава на установяване: България (ЕС)",
    copyright: "© {{year}} МЕДИА СТИЛ 25 ЕООД (търговско наименование MEDIA-STYLE). Всички права запазени.",
    builtIn: "Създадено с гордост в България",
    securePayments: "Сигурни плащания с",
  },
};
